import React from 'react'

import { MainLayout } from 'src/common/layouts/MainLayout/MainLayout'
import { Resume } from 'src/graphql/types'
import { StoryClientType } from 'src/strapi/types/storiesTypes'
import { AnalyticEventEnum } from 'src/utils/analytic/analyticEventEnum'
import { useAnalytic } from 'src/utils/analytic/useAnalytic'

import { DomainOrSkillAwardBlock } from './DomainOrSkillAwardBlock/DomainOrSkillAwardBlock'
import { DomainOrSkillFAQBlock } from './DomainOrSkillFAQBlock/DomainOrSkillFAQBlock'
import { DomainOrSkillFoundersBlock } from './DomainOrSkillFoundersBlock/DomainOrSkillFoundersBlock'
import { DomainOrSkillGetMatchedBlock } from './DomainOrSkillGetMatchedBlock/DomainOrSkillGetMatchedBlock'
import { DomainOrSkillIntroBlock } from './DomainOrSkillIntroBlock/DomainOrSkillIntroBlock'
import { DomainOrSkillMediaBlock } from './DomainOrSkillMediaBlock/DomainOrSkillMediaBlock'
import { DomainOrSkillMeta } from './DomainOrSkillMeta/DomainOrSkillMeta'
import { DomainOrSkillResumes } from './DomainOrSkillResumes/DomainOrSkillResumes'
import { DomainOrSkillStartupBlock } from './DomainOrSkillStartupBlock/DomainOrSkillStartupBlock'
// import { DomainOrSkillTrustedBlock } from './DomainOrSkillTrustedBlock/DomainOrSkillTrustedBlock'
import { DomainOrSkillVettingBlock } from './DomainOrSkillVettingBlock/DomainOrSkillVettingBlock'

import s from './DomainOrSkillPage.module.scss'

// NOTICE common entity required for the page
export type DomainSkillEntity = {
  icon: string
  publicName: string
  url: string
  rating: number
  type: 'skill' | 'domain'
  developersCount: number
  clientReviewsCount: number
  resumesIds: string[]
}

export type DomainOrSkillPageProps = {
  domainOrSkillEntity: DomainSkillEntity
  resumes: Array<Resume>
  stories: Array<StoryClientType>
}

export const DomainOrSkillPage: React.FC<DomainOrSkillPageProps> = ({
  domainOrSkillEntity,
  resumes,
  // stories,
}) => {
  const { analytic } = useAnalytic()

  const {
    publicName,
    clientReviewsCount,
    icon,
    developersCount,
    rating,
    type,
  } = domainOrSkillEntity

  analytic.event(
    type === 'domain'
      ? AnalyticEventEnum.DOMAIN_PAGE
      : AnalyticEventEnum.SKILL_PAGE,
    { name: publicName }
  )

  return (
    <>
      <DomainOrSkillMeta publicName={publicName} />

      <MainLayout pageAnalytic={type === 'domain' ? 'domain' : 'skill'}>
        <div className={s.DomainOrSkillPage__bg}>
          <DomainOrSkillIntroBlock
            name={publicName}
            icon={icon}
            clientReviewsCount={clientReviewsCount}
            developersCount={developersCount}
            rating={rating}
          />
          <DomainOrSkillResumes
            resumes={resumes}
            skillName={publicName}
            developersCount={developersCount}
          />
          <DomainOrSkillStartupBlock name={publicName} />
        </div>

        <DomainOrSkillVettingBlock />
        <DomainOrSkillAwardBlock />

        <div className={s.DomainOrSkillPage__foundersGradient}>
          {/* <DomainOrSkillTrustedBlock stories={stories} /> */}
          <DomainOrSkillFoundersBlock />
        </div>

        <DomainOrSkillMediaBlock />
        <DomainOrSkillGetMatchedBlock />
        <DomainOrSkillFAQBlock />
      </MainLayout>
    </>
  )
}
